export const updateFloatDigits = value => {
  return Number(value) || Number(value) === 0 ? parseFloat(value).toFixed(2) : '0.00';
};
